import { render } from "./UiModalProps.vue?vue&type=template&id=77afa8a6"
import script from "./UiModalProps.vue?vue&type=script&lang=js"
export * from "./UiModalProps.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__